import { Table } from "@kanda-libs/ks-component-ts";
import type { FunctionComponent } from "react";
import useCompanyTableProps from "components/company/CompanyTable/useCompanyTableProps";

export interface CompanyTableProps {}

const CompanyTable: FunctionComponent<CompanyTableProps> = function ({}) {
  const tableProps = useCompanyTableProps();

  return <Table {...tableProps} />;
};

export default CompanyTable;
